// Everything in this file must be imported or prefixed with window
// to avoid "Uncaught ReferenceError: <variable> is not defined"

const $ = window.$;
const _ = window._;
const Backbone = window.Backbone;
const d3 = window.d3;
const EXIF = window.EXIF;
const FastClick = window.FastClick;
const Hammer = window.Hammer;
const numeral = window.numeral;
const Papa = window.Papa;
const SVG = window.SVG;
const tinycolor = window.tinycolor;
const Typo = window.Typo;
const WordCloud = window.WordCloud;
const venn = window.venn;
const Lethargy = window.Lethargy;
const PptxGenJS = window.PptxGenJS;

export {
    $,
    _,
    Backbone,
    d3,
    EXIF,
    FastClick,
    Hammer,
    Lethargy,
    numeral,
    Papa,
    SVG,
    tinycolor,
    Typo,
    WordCloud,
    venn,
    PptxGenJS
};
